<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent>
                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input v-model="filters.ActivityManagement.sales_promoter" :multiple="true"
                        :options="options.salesPromoterSearch" class="lg:pr-6 w-full lg:w-1/4" label="Promotor" />
                    <multi-select-input v-model="filters.ActivityManagement.market_network" :multiple="true"
                        :options="options.marketNetworkSearch" class="lg:pr-6 w-full lg:w-1/4" label="Rede" />
                    <multi-select-input v-model="filters.ActivityManagement.market" :multiple="true"
                        :options="options.marketSearch" class="lg:pr-6 w-full lg:w-1/4" label="Loja" />
                    <multi-select-input v-model="filters.ActivityManagement.provider" :multiple="true"
                        :options="options.providerSearch" class="lg:pr-6 w-full lg:w-1/4" label="Fornecedor" />
                    <multi-select-input v-model="filters.ActivityManagement.brand" :multiple="true"
                        :options="options.brandSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Marca" />
                    <multi-select-input v-model="filters.ActivityManagement.products" :multiple="true"
                        :options="options.productSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Produtos" />
                    <multi-select-input v-model="filters.ActivityManagement.status" :multiple="true"
                        :options="statustSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Status" />
                    <multi-select-input v-model="filters.ActivityManagement.state" :multiple="true"
                        :options="options.statesSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Estado" />
                    <multi-select-input v-model="filters.ActivityManagement.city" :multiple="true"
                        :options="options.citysSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Cidade" />
                    <multi-select-input v-model="filters.ActivityManagement.zone" :multiple="true"
                        :options="options.zoneSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Região" />
                    <date-input v-model="filters.ActivityManagement.date_start" class="lg:pr-6 w-full lg:w-1/4 lg:mt-4"
                        label="Data Inicial" />
                    <date-input v-model="filters.ActivityManagement.date_end" class="lg:pr-6 w-full lg:w-1/4 lg:mt-4"
                        label="Data Final" />
                </div>
                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                    <button @click="reloadData"
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                    </button>
                    <button class="btn flex items-center text-purple-100 font-roboto font-medium
           px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100" @click="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                    </button>
                </div>
            </form>
        </div>

        <Head title="Gerenciamento de Atividades" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
                <span class="whitespace-nowrap overflow-hidden">Gerenciamento de Atividades</span>
            </h1>
            <data-table v-if="loadTable" v-model:columns="columns" :route="'activity_management/list'" :query="getQuery"
                no-data-label="Nenhuma atividade cadastrada" no-result-label="Nenhuma atividade encontrada">
                <template #table.cell.content.produto="{ value, row }">
                    <div class="place-self-center grid-cols-2 gap-4">
                    </div>
                </template>

                <template #table.cell.content.sales_promoter_label="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.market_network="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.market="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.state="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.city="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.provider="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.brand="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.date="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.status="{ value, row }">
                    <Link :href="'activity_management/detail/' + row.reportId" class="block px-4 py-3">{{ value }}
                    </Link>
                </template>

                <template #table.cell.content.actions="{ value, row }">
                    <div class="inline-grid gap-4 ">
                        <Link :href="'activity_management/detail/' + row.reportId"
                            class="btn-purple font-normal text-xs px-6 py-2.5">
                        Ver Relatório
                        <font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                        </Link>
                    </div>
                </template>
                <template #grid.content.body.actions="{ value, row }">
                    <div class="inline-grid gap-4 ">
                    </div>
                </template>

                <template #after.reload-button>
                    <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                        @click.prevent="handlerExportPdf">
                        <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span
                            class="hidden lg:block">
                            Atividades em PDF</span>
                    </button>
                </template>
            </data-table>
        </div>

        <Modal size="modal-lg" ref="showModalPdf">
            <template #header>
                <div class="text-gray-777 font-roboto uppercase w-full">
                    Histórico de relatórios PDF exportados
                </div>
            </template>

            <template #body>
                <p>Deseja exportar um novo arquivo?</p>
                <button class="inline-block text-center w-[180px] py-3 px-4 btn-purple mt-4"
                    :class="{ 'opacity-50 cursor-not-allowed': isExporting }" :disabled="isExporting"
                    @click="handlerSendToExportData">
                    <font-awesome-icon icon="fa-file-pdf" class="text-purple text-sm mr-0 lg:mr-2" />
                    <span v-if="!isExporting">Exportar PDF</span>
                    <span v-else>Processando...</span>
                </button>

                <data-table v-if="exportedTable" v-model:columns="columnsExported"
                    route="activity_management/export/pdf" no-data-label="Nenhum registro encontrado"
                    no-result-label="Nenhum registro encontrado" class="data-table mt-6">

                    <template #table.cell.content.actions="{ value, row }">
                        <button @click="downloadExportedFile(row.id)"
                            class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm mr-4">
                            <font-awesome-icon icon="fa-download" class="text-white px-2" />
                        </button>

                        <button @click="deleteExportedFile(row.id)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-trash-can" class="text-white px-2" />
                        </button>
                    </template>
                </data-table>
            </template>
            <template #footer>
                <button type="button"
                    class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                    @click.prevent="closeModalHistoric">Cancelar</button>
            </template>
        </Modal>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'

import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import DateInput from '@/Shared/DateInput'
import TooltipInfo from '@/Shared/TooltipInfo'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import Modal from '@/Shared/Modal'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'

export default {
    components: {
        Head,
        LoadingButton,
        TextInput,
        DateInput,
        DataTable,
        TooltipInfo,
        MultiSelectInput,
        Link,
        Modal,
    },
    props: {
        statustSearch: Array,
        salesPromoterSearch: Array,
    },
    layout: Layout,

    mixins: [
        getFiltersMixin,
    ],

    data() {
        return {
            loadTable: true,
            showFilters: false,
            exportedTable: true,
            isExporting: false,

            options: {
                salesPromoterSearch: [],
                marketNetworkSearch: [],
                marketSearch: [],
                providerSearch: [],
                brandSearch: [],
                productSearch: [],
                statesSearch: [],
                citysSearch: [],
                zoneSearch: [],
            },

            columns: [
                {
                    uniqid: 'sales_promoter_label',
                    label: 'PROMOTOR',
                    field: 'sales_promoter_label',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.sales_promoter_label ? row.sales_promoter_label : ''
                },
                {
                    uniqid: 'market_network',
                    label: 'Rede',
                    field: 'marketNetworkName',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'market',
                    label: 'Loja',
                    field: 'marketUnit',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'state',
                    label: 'UF',
                    field: 'state',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.state ? row.state : ''
                },
                {
                    uniqid: 'city',
                    label: 'Cidade',
                    field: 'city',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.city ? row.city : ''
                },
                {
                    uniqid: 'provider',
                    label: 'FORNECEDOR',
                    field: 'providerName',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'brand',
                    label: 'Marca',
                    field: 'brandName',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'date',
                    label: 'Data/Hora',
                    field: 'date',
                    visible: true,
                    sortable: true,
                    sortOrder: 'desc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => this.$filters.formatDateTime(row.date),
                },
                {
                    uniqid: 'status',
                    label: 'Status',
                    field: 'status',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.statusLabel ? row.statusLabel : ''
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
            ],

            columnsExported: [
                {
                    uniqid: 'date',
                    label: 'Gerado',
                    field: 'created_at',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const createdAt = new Date(val)
                        return createdAt.toLocaleString('pt-br');
                    },
                },
                {
                    uniqid: 'title',
                    label: 'Nome',
                    field: 'title',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'status',
                    label: 'Status',
                    field: 'status',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const status = {
                            finish: 'Sucesso',
                            failed: 'Falhou',
                            processing: 'Processando',
                        }
                        return status[val]
                    }
                },
                {
                    uniqid: 'size',
                    label: 'Tamanho',
                    field: 'size',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        if (row.file)
                            return `${(row.file.size / (1024 * 1024)).toFixed(2)}MB`
                    }
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'actions',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                },
            ],
        }
    },

    computed: {
        getQuery() {
            return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
        },
    },

    watch: {
        'filters.ActivityManagement': {
            handler() {
                this.getFiltersFromAPI()
            },
            deep: true,
        }
    },

    methods: {
        reloadData() {
            this.getFiltersFromAPI()
            this.reloadTable()
        },

        reloadTable() {
            this.loadTable = false;
            setTimeout(() => this.loadTable = true, 10);
        },
        clearSearch() {
            this.clearFilters()
            this.getFiltersFromAPI()
            this.reloadTable();
        },

        handlerExportPdf(value = true) {
            this.$refs.showModalPdf.showModal = value
        },

        closeModalHistoric() {
            this.$refs.showModalPdf.showModal = false
        },

        async handlerSendToExportData() {
            if (this.isExporting) return
            this.isExporting = true
            const filters = this.getFilters()

            try {
                const response = await axios.post('/activity_management/general-report', filters)

                if (response.status === 202 || response.status === 200) {
                    const msg = response.data?.message ?? 'Exportação iniciada'
                    this.$toast && this.$toast.success(msg)

                    this.reloadExportedTable()
                }
            } catch (err) {
                if (axios.isAxiosError(err))
                    this.$toast && this.$toast.error(err.response?.data?.message || 'Erro ao exportar')
                else
                    this.$toast && this.$toast.error('Erro ao fazer requisição')
            } finally {
                this.isExporting = false
            }

            this.handlerExportPdf(false)
        },

        downloadExportedFile(id) {
            window.open(`/activity_management/export/pdf/download/${id}`)
        },

        async deleteExportedFile(id) {
            try {
                const response = await axios.delete(`/activity_management/export/pdf/${id}`)
                if (response.status === 200)
                    this.$toast && this.$toast.success(response.data.message)
            } catch (err) {
                if (axios.isAxiosError(err))
                    this.$toast && this.$toast.error(err.response?.data?.message || 'Erro ao excluir')
                else
                    this.$toast && this.$toast.error('Erro ao fazer requisição')
            }

            this.reloadExportedTable()
        },

        reloadExportedTable() {
            this.exportedTable = false
            setTimeout(() => this.exportedTable = true, 10)
        },
    },


    setup() {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent('ActivityManagement')

        const clearFilters = () => clearFiltersComponent('ActivityManagement')
        const getFilters = () => getFiltersComponent('ActivityManagement')

        return {
            getFilters,
            clearFilters,
            filters: filtersStore.filters
        }
    },
}
</script>
